<template>
  <div class="container">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>返回</span>
    </div>
    <a-form :form="form">
      <div class="header">
        <span class="title">{{ !id ? '新建知识库' : '编辑知识库' }}</span>
      </div>
      <div class="list">
        <a-form-item :label="'知识库名称'" :colon="false">
          <a-input
            maxLength="15"
            v-decorator="['name', { rules: [{ required: true, message: '请输入知识库名称' }] }]"
            placeholder="请输入知识库名称"
          />
        </a-form-item>
        <a-form-item :label="'描述'" :colon="false">
          <a-textarea
            maxLength="500"
            v-decorator="['description', { rules: [{ required: true, message: '请输入知识库描述' }] }]"
            placeholder="请输入知识库描述"
            :auto-size="{ minRows: 1, maxRows: 6 }"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="'归属权限'" :colon="false">
          <a-select
            v-decorator="['permission', { initialValue: '1', rules: [{ required: true, message: '请选择归属权限' }] }]"
          >
            <a-select-option value="1">
              个人
            </a-select-option>
            <a-select-option value="2" v-if="isAdmin">
              学院
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="'专业'" :colon="false" v-if="this.form.getFieldValue('permission') == '2'">
          <a-cascader
            class="search-item"
            :options="professionList"
            placeholder="请选择专业"
            v-decorator="['permissionArr', { rules: [{ type: 'array', required: true, message: '请选择专业' }] }]"
          >
          </a-cascader>
        </a-form-item>
        <a-form-item :label="'状态'" :colon="false">
          <a-select
            v-decorator="['status', { initialValue: '1', rules: [{ required: true, message: '请选择状态' }] }]"
            placeholder="请选择状态"
          >
            <a-select-option value="1">
              启用
            </a-select-option>
            <a-select-option value="2">
              禁用
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </a-form>
    <div class="list-button">
      <a-button type="primary" @click="save" class="gray">{{ id ? '完成编辑' : '完成创建' }}</a-button>
      <a-button type="primary" @click="e => save(e, true)">{{ id ? '编辑并导入' : '创建并导入' }}</a-button>
    </div>
  </div>
</template>
<script>
import { createDataset, getDatasetDetail } from '@/api/ai'
import { getAdminOrgList } from '@/api/lesson'
import Pagination from '@/components/pagination/index.vue'
import NoData from '@/components/noData/index'

export default {
  components: {
    NoData,
    Pagination
  },
  data() {
    return {
      id: undefined,
      list: [],
      locale: {
        emptyText: <NoData />
      },
      pagination: {
        page: 1,
        pageSize: 5,
        total: 0,
        hideOnSinglePage: true
      },
      form: this.$form.createForm(this),
      professionList: [],
      isAdmin: false
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'repository'
      })
    },
    // 获取知识库详情
    getDetail() {
      if (!this.id) return

      getDatasetDetail({ id: this.id }).then(res => {
        if (res.code === 200) {
          const data = res.data

          // 设置表单初始值
          this.form.setFieldsValue({
            name: data.name,
            description: data.description,
            permission: data.permission,
            status: data.status
          })

          // 如果是学院权限，需要设置专业信息
          if (data.permission === '2' && data.collegeId) {
            const permissionArr = []

            if (data.collegeId) permissionArr.push(data.collegeId)
            if (data.departmentId) permissionArr.push(data.departmentId)
            if (data.professionId) permissionArr.push(data.professionId)

            if (permissionArr.length > 0) {
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  permissionArr: permissionArr
                })
              })
            }
          }
        }
      })
    },

    save(e, isImport = false) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values)
          if (data.permissionArr && data.permissionArr.length > 0) {
            data.collegeId = data.permissionArr[0]
            data.departmentId = data.permissionArr[1]
            data.professionId = data.permissionArr[2]
            delete data.permissionArr
          }

          console.log('Received values of form: ', data)

          // 根据是否有 id 判断是创建还是更新
          const request = this.id ? createDataset({ ...data, datasetId: this.id }) : createDataset(data)

          request.then(res => {
            if (res.code == 200) {
              const tip = this.id ? '编辑' : '创建'
              this.$message.success(tip + '成功！')
              if (isImport) {
                this.$router.push({
                  name: 'createFlow',
                  query: {
                    id: res.data.id || this.id
                  }
                })
              } else {
                this.back()
              }
            }
          })
        }
      })
    },
    getProfessionList() {
      getAdminOrgList().then(res => {
        if (res.code === 200) {
          this.professionListFind = []
          for (let item of res.data.list) {
            this.professionList.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name,
                      isLeaf: true
                    }
                  })
                }
              })
            })
          }
        }
      })
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getProfessionList()
    const roles = JSON.parse(localStorage.roles)
    if (roles.includes('admin')) {
      this.isAdmin = true
    }
    // 如果有 id，获取详情数据
    if (this.id) {
      this.getDetail()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 21px;
  /deep/ textarea {
    min-height: 35px !important;
    padding: 6px 11px;
  }
}
.header {
  margin-bottom: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ededed;
  .title {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.button {
  cursor: pointer;
}
.ant-form {
  position: relative;
  height: calc(100% - 100px);
  .list {
    display: flex;
    margin-bottom: 12px;
    flex-wrap: wrap;
    .ant-form-item-label {
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }
    .ant-form-item {
      width: calc((100% - 70px) / 2);
      margin-bottom: 0;
      &:first-child {
        margin-right: 70px;
      }
    }
    /deep/.select-button.ant-btn.disabled {
      color: #a2a2a2 !important;
      background: none;
    }
    /deep/.ant-input,
    /deep/.select-button.ant-btn,
    /deep/.ant-input-affix-wrapper {
      width: 100%;
      height: 35px;
      color: #000000 !important;
      margin-right: 11px;
    }
    /deep/.ant-select-selection__rendered {
      .ant-select-selection-selected-value {
        color: #000;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input .ant-input {
        width: 100%;
        height: 35px;
        margin-right: 0;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .select-button,
    .ant-calendar-picker {
      width: 100%;
      height: 35px;
      color: #000000;
      line-height: 35px;
    }
    .select-button {
      padding: 0 20px;
      text-align: left;
      color: #a2a2a2;
      position: relative;
      img {
        top: 14px;
        width: 11px;
        right: 20px;
        position: absolute;
      }
    }
  }
}
.list-button {
  display: flex;
  justify-content: center;
  .gray {
    margin-right: 20px;
    background: linear-gradient(248deg, #72899d 0%, #9bb3c8 100%);
  }
}
/deep/.ant-modal {
  width: 737px !important;
  .ant-modal-title {
    font-size: 16px;
    font-weight: 550;
  }
  .total {
    color: #687f9c;
    margin: 12px 0;
  }
  .ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    margin-bottom: 22px;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      height: 35px;
      .ant-input {
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #d8dce0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn {
      border-left: 0;
      height: 35px;
      border-color: #d8dce0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span {
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        &::before {
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #e9e9e9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  .ant-modal-body {
    position: relative;
    .ant-table-wrapper {
      margin-bottom: 60px;
      .prepare-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
        display: inline-block;
      }
      .button {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #5b7499;
        line-height: 20px;
        margin-right: 10px;
      }
    }
    .list-pagination {
      width: calc(100% - 48px);
      bottom: 80px;
      position: absolute;
      .pagination {
        padding: 25px 0;
      }
    }
  }
}
.ant-table,
.ant-btn {
  color: #000;
}
</style>
